import { render, staticRenderFns } from "./EventRowComponent.vue?vue&type=template&id=096c4f30&scoped=true&"
import script from "./EventRowComponent.vue?vue&type=script&lang=js&"
export * from "./EventRowComponent.vue?vue&type=script&lang=js&"
import style0 from "./EventRowComponent.vue?vue&type=style&index=0&id=096c4f30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c4f30",
  null
  
)

export default component.exports